<template>
  <div class="relative right-0 h-content-window flex">
    <WindowLeftMenu :leftMenuType="props.leftMenuType" />
    <div class="w-full h-full bg-white overflow-auto overflow-x-hidden pb-8 md:pb-5 relative">
      <div class="m-2">
        <section>
          <div class="grid grid-cols-2 gap-x-1.5 gap-y-0">
            <div
              v-for="game in games"
              :key="game.id"
              @click="focusGame(game)"
              @dblclick="openGame(game)"
              class="flex items-center gap-1 cursor-pointer"
              :class="{ active: game.isFocused }"
            >
              <img :src="game.iconSrc" :alt="getGameTitle(game.id)" class="w-11 h-11" :style="{ opacity: game.isFocused ? 0.6 : 1 }" />
              <div
                class="px-1 text-left"
                :style="{
                  backgroundColor: game.isFocused ? '#0B61FF' : 'transparent',
                  color: game.isFocused ? 'white' : 'black'
                }"
              >
                <p class="text-xs font-tahoma font-medium leading-tight">{{ getGameTitle(game.id) }}</p>
                <p :class="'text-xxs ' + [game.isFocused ? 'text-gray-192' : 'text-gray-400']">{{ getGameSubtitle(game.id) }}</p>
                <p :class="'text-xxs ' + [game.isFocused ? 'text-gray-192' : 'text-gray-400']">Game</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import { useLocaleStore } from '@/stores/localeStore'
import WindowLeftMenu from '@/components/Windows/WindowLeftMenu.vue'

const props = defineProps({
  leftMenuType: String
})

const localeStore = useLocaleStore()

const getGameTitle = (id) => {
  const titles = {
    minesweeper: { en: 'Minesweeper', fr: 'Démineur' },
    gorillas: { en: 'Gorillas', fr: 'Gorilles' },
    stickHero: { en: 'Stick Hero', fr: 'Stick Hero' },
    chess: { en: 'Chess', fr: 'Échecs' }
  }
  return titles[id]?.[localeStore.currentLocale] || titles[id]?.en || id
}

const getGameSubtitle = (id) => {
  const subtitles = {
    minesweeper: { en: 'Classic game', fr: 'Jeu classique' },
    gorillas: { en: 'Classic gorilla throwing game', fr: 'Jeu classique de lancer de gorille' },
    stickHero: { en: 'Classic stick hero game', fr: 'Jeu classique de stick hero' },
    chess: { en: 'Classic chess game', fr: 'Jeu d\'échecs classique' }
  }
  return subtitles[id]?.[localeStore.currentLocale] || subtitles[id]?.en || ''
}

const games = ref([
  {
    id: 'minesweeper',
    iconSrc: '/img/icons/minesweeper/minesweeper-icon-sm.webp',
    isFocused: false
  },
  {
    id: 'gorillas',
    iconSrc: '/img/icons/gorillas/Gorillas.webp',
    isFocused: false
  },
  {
    id: 'stickHero',
    iconSrc: '/img/icons/Stick Hero/Stick Hero.webp',
    isFocused: false
  },
  {
    id: 'chess',
    iconSrc: '/chess/chess.webp',
    isFocused: false
  }
])

const focusGame = (game) => {
  games.value.forEach((g) => {
    g.isFocused = false
  })
  game.isFocused = true
}

const openGame = (game) => {
  // Dispatch custom event to open the game window
  window.dispatchEvent(new CustomEvent('open-window', {
    detail: { windowId: game.id }
  }))
}
</script>

<style scoped>
.active {
  outline: 1px dashed #0B61FF;
  outline-offset: 2px;
}
</style>

